import { clsx } from 'clsx';

import type { LineLoaderProps } from 'ui';

import type { ButtonProps } from './types';

interface AtomProps {
  className?: string;
  style?: Record<string, string | number>;
}

type UseButtonView = (
  props: ButtonProps,
  classes: Record<string, string>,
) => {
  rootProps: AtomProps;
  labelProps: AtomProps;
  startAdornmentProps: AtomProps;
  endAdornmentProps: AtomProps;
  loaderProps: LineLoaderProps;
};

export const useButtonView: UseButtonView = (
  {
    shape = 'round',
    color = 'primary',
    size = 'md',
    invertPalette = false,
    disabled = false,
    loading = false,
    flexFullSize = false,
    widthFullSize = false,
    focused = false,
    isIcon = false,
    textAlign = 'center',
    style,
    className,
  },
  classes,
) => {
  return {
    rootProps: {
      className: clsx(
        classes.root,
        {
          [classes.invert]: invertPalette,
          [classes[`color-${color}`]]: color,
          [classes[`size-${size}`]]: size,
          [classes[`shape-${shape}`]]: shape,
          [classes.disabled]: disabled,
          [classes.loading]: loading,
          [classes.isIcon]: isIcon,
          [classes.focused]: focused,
        },
        className,
      ),
      style: {
        flex: flexFullSize ? 1 : 'initial',
        width: widthFullSize ? '100%' : 'initial',
        ...style,
      },
    },
    labelProps: {
      className: classes.label,
      style: {
        textAlign,
      },
    },
    startAdornmentProps: {
      className: classes.startAdornment,
    },
    endAdornmentProps: {
      className: classes.endAdornment,
    },
    loaderProps: {
      height: '100%',
      position: 'absolute',
      color: 'ghost',
    },
  };
};
